import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=332ec34e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332ec34e"]])

export default __exports__